import React from 'react';
import styles from '../../styles/ReporteEstudiantesCarreraStyles/ReporteEstudiantesCarrera.module.css';
import { getTurnoLabel } from '../../constants/turnos';

/**
 * Tabla del reporte con paginación SERVIDOR.
 *
 * Props:
 *  - resultados:  Array<{ numero, matricula, nombre, genero, tetra_en_curso, turno }>
 *  - contexto:    { ciclo, campus, seccion, programa }
 *  - page, pageSize, total, totalPages
 *  - onPageChange(newPage)
 */
function TablaReporte({
  resultados = [],
  contexto = {},
  page = 1,
  pageSize = 15,
  total = 0,
  totalPages = 1,
  onPageChange,
}) {
  const fromRow = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const toRow = Math.min(page * pageSize, total);

  const goTo = (p) => {
    if (typeof onPageChange === 'function') {
      onPageChange(Math.max(1, Math.min(totalPages, p)));
    }
  };

  return (
    <>
      <div className={styles.reportHeader}>
        <h2 className={styles.reportTitle}>REPORTE ESTUDIANTES POR CARRERA</h2>
      </div>

      <div className={styles.reportMeta}>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Ciclo:</span>
          <span>{contexto.ciclo || '—'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Carrera:</span>
          <span>{contexto.programa || '—'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Campus:</span>
          <span>{contexto.campus || 'Todos'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Sección:</span>
          <span>{contexto.seccion || 'Todas'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Total:</span>
          <span>{total}</span>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.reportTable}>
          <thead>
            <tr>
              <th className={styles.cellCenter}>#</th>
              <th>Matrícula</th>
              <th>Nombre</th>
              <th>Género</th>
              <th className={styles.cellCenter}>Tetra en curso</th>
              <th>Turno</th>
            </tr>
          </thead>
          <tbody>
            {resultados.length === 0 ? (
              <tr>
                <td colSpan={6} className={styles.cellCenter} style={{ padding: '20px', color: '#999' }}>
                  No hay estudiantes para los filtros aplicados.
                </td>
              </tr>
            ) : (
              resultados.map((r, idx) => (
                <tr key={`${r.id_estudiante || r.matricula}-${idx}`}>
                  <td className={styles.cellCenter}>{r.numero ?? ((page - 1) * pageSize + idx + 1)}</td>
                  <td>{r.matricula || ''}</td>
                  <td>{r.nombre || ''}</td>
                  <td>{r.genero || ''}</td>
                  <td className={styles.cellCenter}>{r.tetra_en_curso ?? ''}</td>
                  <td>{getTurnoLabel(r.turno) || ''}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {total > 0 && (
        <div className={styles.pagination}>
          <span className={styles.pageInfo}>
            Mostrando {fromRow}–{toRow} de {total}
          </span>
          <div className={styles.pageButtons}>
            <button
              type="button"
              className={styles.pageButton}
              onClick={() => goTo(page - 1)}
              disabled={page <= 1}
            >
              « Anterior
            </button>
            <span className={styles.pageInfo}>Página {page} de {totalPages}</span>
            <button
              type="button"
              className={styles.pageButton}
              onClick={() => goTo(page + 1)}
              disabled={page >= totalPages}
            >
              Siguiente »
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default TablaReporte;
